module.exports = __webpack_public_path__ + "static/media/logo_dash.91f67eac.png";